import { render, staticRenderFns } from "./offlinewarning.vue?vue&type=template&id=284c2475&"
import script from "./offlinewarning.vue?vue&type=script&lang=ts&"
export * from "./offlinewarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports